<template>
	<div>

		<section class="bg-green-light">
			<div class="container h-100">
				<div class="row">
					<div class="col 12 text-center mb-4" style="margin-top:150px;">
						<h1>{{classData.classe != 0 ? classData.classe + classData.sezione : classData.sezione}}</h1>
						<p class="font-grandstander fs-1-25">
							SCUOLA "{{school}}"
						</p>
					</div>
				</div>
			</div>
		</section>

		<section id="motto" class="pt-5 pb-4">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-xxl-10">

						<div class="row">

							<div class="col-12 text-center">
								<h1 class="fs-2-5 mb-4">Carica il motto obbligatorio per partecipare all’iniziativa libera e, se vuoi, un disegno</h1>
							</div>

							<div class="col-12">
								<form id="motto-form" @submit.prevent="submitMotto">
									<div class="row">
										<div class="col-12 form-group text-center">
											<label for="motto-text" class="font-grandstander text-yellow fs-1-6 mb-2">INSERISCI IL MOTTO</label>
											<textarea name="motto-text" id="motto-text" class="form-control form-control-lg" placeholder="Scrivi il motto" rows="5" maxlength="130" minlength="8" v-model="forms.mottoText" required :disabled="isBtnMottoDisabled"></textarea>
										</div>
										<div class="col-12 text-right">
											<small>Massimo 130 caratteri</small>
										</div>
									</div>
									<div class="row">
										<div class="col-12 form-group text-center">
											<button type="submit" class="btn btn-yellow rounded-pill px-4 py-0" :disabled="isBtnMottoDisabled || spinners.isMottoSubmitting"><span class="va-m">CONFERMA</span> <i class="fas fa-circle-notch fa-spin va-sub ml-2" :class="[spinners.isMottoSubmitting ? 'd-inline-block' : 'd-none']"></i></button>
										</div>
									</div>
									<div class="row">
										<div class="col-12 text-center" style="min-height: 24px;">
											<span v-html="mgsMotto"></span>
										</div>
									</div>
								</form>
							</div>

						</div>

					</div>
				</div>
			</div>
		</section>

		<section id="class-img" :class="{'op-low': isMediaFormDisabled}">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-xxl-10">

						<div class="row justify-content-center">
							<div class="col-md-8 col-xl-6">
								<hr>
							</div>

							<div class="col-12 py-4">
								<form @submit.prevent="submitMedia">

									<div class="col-12 text-center mb-2">
										<p for="motto-text" class="font-grandstander text-yellow fs-1-6 mb-3">CARICA LA FOTO</p>
									</div>

									<div class="col-12 form-group mb-0 mt-1 text-center">
										<label for="file-upload" class="custom-file-upload fs-1-1 bold rounded-pill px-4" role="button" :disabled="isBtnMediaDisabled">
											<span class="va-baseline font-grandstander">SFOGLIA</span> <span class="icon-upload-svgrepo-com bold ml-2"></span>
										</label>
										<input id="file-upload" type="file" ref="file" @change="processFile($event)" accept="image/png, image/jpeg"  :disabled="isBtnMediaDisabled || spinners.isMediaSubmitting">
									</div>

									<div class="col-12 text-center">
										<small>Max 10 MB, in formati JPEG e PNG.</small>
									</div>

									<div class="col-12 text-center" v-if="urlPreview">
										<p v-html="msgSelectedFile"></p>
										<img :src="urlPreview" alt="Preview" style="max-width: 250px;height:auto;">
									</div>

									<div class="col-12 form-group text-center mt-3">
										<button type="submit" class="btn btn-yellow rounded-pill px-4 py-0" :disabled="isBtnMediaDisabled || spinners.isMediaSubmitting"><span class="va-m">CONFERMA</span> <i class="fas fa-circle-notch fa-spin va-sub ml-2" :class="[spinners.isMediaSubmitting ? 'd-inline-block' : 'd-none']"></i></button>
									</div>
									<div class="row">
										<div class="col-12 text-center" style="min-height: 24px;">
											<span v-html="msgMedia"></span>
										</div>
									</div>

								</form>
							</div>

							<div class="col-md-8 col-xl-6">
								<hr>
							</div>
						</div>

					</div>
				</div>
			</div>
		</section>

		<section id="return" class="position-relative" style="padding-bottom: 8%;">
			<div class="container">
				<div class="row">
					<div class="col-12 text-center">
						<button class="btn btn-yellow-o rounded-pill px-4 py-0 mb-4 mt-2" @click.prevent="goBack"><span class="va-sub">TORNA INDIETRO</span></button>
					</div>
				</div>
			</div>

			<div class="grass w-100">
				<img :src="themeDir + 'img/erba.png'" class="img-fluid w-100">
			</div>
		</section>

		<!-- ** Modal ************************* -->
		<modal name="msg-modal"
			height="auto"
			:adaptive=true
			:maxWidth="400"
			id="msg-modal"
		>
			<div class="container">
				<div class="row" style="margin-right:-2rem;">
					<div class="col-12 text-right lh-0-9"><i class="fas fa-times hover-default fs-1-8 lh-1" @click.prevent="$modal.hide('msg-modal')"></i></div>
				</div>
				<div class="row">
					<div class="col-12 text-center">
						<h3 v-html="msgModal.title"></h3>
					</div>
					<div class="col-12 text-center">
						<p class="fs-1-2 mb-0" v-html="msgModal.msg"></p>
					</div>
				</div>
			</div>
		</modal>

	</div>
</template>

<script>
import axios from 'axios'
import {urlBase, themeDir} from '../../variables'

export default {
	name: 'ClassWorkForm',
	props: ['classData', 'school'],

	data() {
		return {
			ajaxObj: window.ajax_object,
			themeDir: urlBase + themeDir,
			isImageFormEnabled: false,
			isTextFormEnabled: false,

			workData: {},

			urlPreview: '',
			msgSelectedFile: '',

			forms: {
				idWork: 0,
				mottoText: '',
				mediaFileSelected: '',
				prevMediaId: 0
			},

			msgModal: {
				title: '',
				msg: ''
			},

			isMediaFormDisabled: true,
			isBtnMottoDisabled: true,
			isBtnMediaDisabled: true,
			isMediaBtnDisabled: false,

			spinners: {
				isMediaSubmitting: false,
				isMottoSubmitting: false
			},
			mgsMotto: '',
			msgMedia: ''
		}
	},

	methods: {
		getClassWorksData() {
			let url = this.ajaxObj.ajax_url

			let formData = new FormData();
			formData.append('action', 'nl_get_class_work_data')
			formData.append('_nounce_value', this.ajaxObj._nounce_value)
			formData.append('class_id', this.classData.id)

			axios.post(url, formData)
				.then((response) => {
					console.log(response.data)
					this.workData = response.data.workItem

					if(this.workData == 0) {
						this.isBtnMottoDisabled = false
					} else {
						if(this.workData.appr_media == 0 && this.workData.text != '') {
							this.isMediaFormDisabled = false
							this.isBtnMediaDisabled = false
						} else if(this.workData.appr_media == 1) {
							this.isMediaFormDisabled = false
							this.isMediaBtnDisabled = false
							this.isBtnMediaDisabled = true
						}
						if(this.workData.appr_text == 0) {
							this.isBtnMottoDisabled = false
						}

						this.forms.mottoText = this.workData.text ? this.workData.text : ''
						this.forms.idWork = this.workData.id ? this.workData.id : ''
						this.forms.prevMediaId = this.workData.id_media ? this.workData.id_media : 0
						this.urlPreview = this.workData.mediaUrl
					}
				}, (error) => {
					console.log(error);
				});
		},

		submitMotto() {
			this.spinners.isMottoSubmitting = true
			this.mgsMotto = ''
			let url = this.ajaxObj.ajax_url

			let formData = new FormData();
			formData.append('action', 'nl_submit_motto')
			formData.append('_nounce_value', this.ajaxObj._nounce_value)
			formData.append('motto', this.forms.mottoText)
			formData.append('id_work', this.forms.idWork)
			formData.append('class_id', this.classData.id)

			axios.post(url, formData)
				.then((response) => {
					console.log(response.data)
					if(response.data.error == '') {
						// this.mgsMotto = response.data.msg
						this.showMsgModal('Perfetto!', response.data.msg)
					} else {
						// this.mgsMotto = response.data.error
						this.showMsgModal('Ops!', response.data.error)
					}
					this.getClassWorksData()
					this.spinners.isMottoSubmitting = false
				}, (error) => {
					this.spinners.isMottoSubmitting = false
					console.log(error);
				});
		},

		submitMedia() {
			if((this.forms.mediaFileSelected == null || this.forms.mediaFileSelected == '' || this.forms.mediaFileSelected == undefined) && this.forms.prevMediaId == 0) {
				this.msgMedia = 'Attenzione: selezionare un immagine da inviare!'
			} else {
				this.spinners.isMediaSubmitting = true
				this.msgMedia = ''
				let url = this.ajaxObj.ajax_url

				let formData = new FormData();
				formData.append('action', 'nl_submit_media')
				formData.append('_nounce_value', this.ajaxObj._nounce_value)
				formData.append('media', this.forms.mediaFileSelected)
				formData.append('prev_media_id', this.forms.prevMediaId)
				formData.append('id_work', this.forms.idWork)
				formData.append('class_id', this.classData.id)

				axios.post(url, formData, {
						headers:{
							'Content-Type' : 'multipart/form-data'
						}
					})
					.then((response) => {
						console.log(response.data)
						if(response.data.error == '') {
							// this.msgMedia = response.data.msg
							this.showMsgModal('Perfetto!', response.data.msg)
						} else {
							//this.msgMedia = response.data.error
							this.showMsgModal('Ops!', response.data.error)
						}
						this.getClassWorksData()
						this.spinners.isMediaSubmitting = false
					}, (error) => {
						this.spinners.isMediaSubmitting = false
						console.log(error);
					});
			}
		},

		processFile(event) {
			console.log(event.target.files[0])
			this.urlPreview = ''
			this.urlPreview = window.URL.createObjectURL(event.target.files[0])
			this.forms.mediaFileSelected = event.target.files[0]
			this.msgSelectedFile = 'File selezionato: <strong>' + this.forms.mediaFileSelected.name + '</strong>'
		},

		showMsgModal(title, msg) {
			this.msgModal.title = title
			this.msgModal.msg = msg
			this.$modal.show('msg-modal')
		},

		goBack() {
			this.$emit('go-back')
		}
	},

	mounted() {
		this.getClassWorksData()
		window.scrollTo({ left: 0, top: 0, behavior: "instant" })
	}
}
</script>

<style scoped>
#upload-icon {
	display: inline-block;
	max-width: 34px;
	height: auto;
}
hr {border-top: 3px solid #00723d;}
</style>
